import { useState } from 'react';
import { useCmsEvents } from '@gov-nx/core/events';
import type { Nullable } from '@gov-nx/core/types';
import { isSmartForm } from '@gov-nx/module/service';
import { useCmsExternalServiceLoader } from './useCmsExternalServiceLoader';

interface CmsExternalServiceModalLoaderProps {
	onAfterClose?: () => void;
}

export const useCmsExternalServiceModalLoader = (
	props?: CmsExternalServiceModalLoaderProps
) => {
	const [id, setId] = useState<Nullable<number>>(null);
	const { loadExternalService, externalService } = useCmsExternalServiceLoader({
		onError: () => setId(null),
	});
	useCmsEvents({
		onCmsExternalServiceModal: async (_, { id }) => {
			setId(id);
			await loadExternalService(id);
		},
	});

	return {
		id,
		onModalClose: () => {
			setId(null);
			props?.onAfterClose && props.onAfterClose();
		},
		externalService,
		isServiceSmartForm: externalService?.links.some(isSmartForm),
	};
};
